var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.18182,
    fill: "#71B48D",
    stroke: "#E4EBF0",
    strokeWidth: 0.363636
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52955 7.36013L5.35984 7.19042L5.19014 7.36013C5.28386 7.45385 5.43582 7.45385 5.52955 7.36013ZM5.35984 6.85101L4.24955 5.74071C4.15582 5.64699 4.00386 5.64699 3.91014 5.74071C3.81641 5.83444 3.81641 5.9864 3.91014 6.08013L5.19014 7.36013L5.35984 7.19042C5.52955 7.36013 5.52953 7.36014 5.52955 7.36013L7.99916 4.89052C8.09288 4.79679 8.09288 4.64483 7.99916 4.55111C7.90543 4.45738 7.75347 4.45738 7.65974 4.55111L5.35984 6.85101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.5921fff75f0369fea19e848b8418a7fc.svg";
export { ForwardRef as ReactComponent };